import {
  GET_PATIENT_VISIT_REMARKS,
  GET_PATIENT_VISIT_REMARKS_SUCCESS,
  CREATE_PATIENT_VISIT_REMARKS,
  CREATE_PATIENT_VISIT_REMARKS_SUCCESS,
} from './PatientSidePanelConstants'
import { SET_ERROR } from '../waitingRoom/WaitingRoomConstants'
import { apiCall } from '../../utils/restclient'
import {
  UPDATE_UPCOMING_VISIT_REMARK,
  UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
  UPDATE_UPCOMING_VISIT_REMARK_ERROR,
} from '../visits/VisitsConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitRemarks = (visitId, tabId) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`
  const action = {
    type: GET_PATIENT_VISIT_REMARKS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_VISIT_REMARKS_SUCCESS,
      error: SET_ERROR,
      extraData: { visitId, tabId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const createVisitRemarks = ({ visitId, Message, tabId, isForceUpdate }) => {
  const endpoint = `api/v1/visits/${visitId}/remarks`
  const action = {
    type: CREATE_PATIENT_VISIT_REMARKS,
  }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({ Message }),
      {
        success: CREATE_PATIENT_VISIT_REMARKS_SUCCESS,
        error: SET_ERROR,
        extraData: { visitId, tabId, isForceUpdate },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const updateUpcomingVisitRemark = ({ visitId, remarkId, Message }) => {
  const endpoint = `api/v1/visits/${visitId}/remarks/${remarkId}`
  const action = {
    type: UPDATE_UPCOMING_VISIT_REMARK,
  }
  try {
    apiCall(
      endpoint,
      'PUT',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify({ Message }),
      {
        success: UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
        error: UPDATE_UPCOMING_VISIT_REMARK_ERROR,
        extraData: { visitId, remarkId },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
